import { useId } from "react";
import PropTypes from "prop-types";
import { HoverCard } from "@hireart/component-library";
import { Left, Value } from "./styles";

export const LeftWithHover = ({ content, theme, width, category }) => {
  const popupId = useId();
  return (
    <HoverCard
      id={popupId}
      content={`${content} hours ${category}`}
      trigger={
        <Left width={width} style={theme}>
          <Value>{content}</Value>
        </Left>
      }
    />
  );
};

LeftWithHover.propTypes = {
  content: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
  width: PropTypes.PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
};
